import React from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { mix } from 'polished';
import get from 'lodash/get';

type Props = {
  className: string | null,
  isVertical?: boolean,
  isActive?: boolean,
  children: Node,
  componentTheme?: Object,
};

export const NavItem = ({ className, isVertical, isActive, componentTheme, children }: Props) => (
  <Item isVertical={isVertical} isActive={isActive} className={className} componentTheme={componentTheme}>
    {isVertical && <BackgroundBar isVertical={isVertical} isActive={isActive} componentTheme={componentTheme} />}
    {children}
  </Item>
);

const verticalNavStyles = css`
  margin-right: 0;
  justify-content: center;
  flex-direction: column;
`;

const Item = styled('li')`
  z-index: 0;
  display: flex;
  align-items: center;
  margin-right: 24px;
  white-space: nowrap;
  position: relative;
  background-color: ${({ theme, isActive, isVertical, componentTheme }) =>
    isVertical
      ? isActive
        ? get(componentTheme, 'Link.activeBackgroundColor', mix(0.15, theme.color.brand, theme.color.white))
        : get(componentTheme, 'Link.backgroundColor')
      : null};

  ${({ isVertical }) => isVertical && verticalNavStyles};
  border-radius: ${({ componentTheme, isVertical }) => isVertical && componentTheme.Link.borderRadius};

  &:active {
    background-color: ${({ theme, isVertical, componentTheme }) =>
      isVertical && get(componentTheme, 'Link.activeBackgroundColor', mix(0.15, theme.color.brand, theme.color.white))};
    box-shadow: ${({ theme, componentTheme, isVertical }) =>
      isVertical && componentTheme.Link.isActiveBarVisible && `inset 8px 0 0 ${get(componentTheme, 'Link.activeColor', theme.color.brand)}`};
  }

  &:active span {
    background-color: ${({ componentTheme, isVertical }) => isVertical && get(componentTheme, 'Link.activeBackgroundColor', componentTheme.Link.backgroundColor)};
  }

  &:last-of-type {
    margin-right: 0;
  }
`;

const BackgroundBar = styled('div')`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: ${({ componentTheme }) => componentTheme.Link.borderRadius};
  box-shadow: ${({ componentTheme }) => componentTheme.Link.boxShadow};
  z-index: -1;

  background-color: ${({ theme, isActive, componentTheme }) =>
    isActive
      ? get(componentTheme, 'Link.activeBackgroundColor', mix(0.15, theme.color.brand, theme.color.white))
      : 'transparent'};
  box-shadow: ${({ theme, componentTheme, isActive }) =>
    isActive &&
    componentTheme.Link.isActiveBarVisible &&
    `inset 8px 0 0 ${get(componentTheme, 'Link.activeColor', theme.color.brand)}`};
`;

NavItem.defaultProps = {
  className: null,
};
